import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListFormuleFormComponent } from './form/formule-form/list-formule-form/list-formule-form.component';
import { NewFormuleFormComponent } from './form/formule-form/new-formule-form/new-formule-form.component';
import { ListFormComponent } from './form/list-form/list-form.component';
import { NewFormComponent } from './form/new-form/new-form.component';
import { HomeComponent } from './home/home.component';
import { ListUsersComponent } from './users/list-users/list-users.component';
import { NewUserComponent } from './users/new-user/new-user.component';
import { ListPc003Component } from './pc003/list-pc003/list-pc003.component';
import { ListPc003EstrategiaComponent } from './pc003/list-pc003-estrategia/list-pc003-estrategia.component';
import { FormPc003Component } from './pc003/new-pc003/pc003.component';
import { ListhumidityComponent } from './humidity/list-humidity/list-humidity.component';
import { FormHumidityComponent } from './humidity/new-humidity/humidity.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'form/list', component: ListFormComponent },
  { path: 'form/new', component: NewFormComponent },
  { path: 'form/edit/:id', component: NewFormComponent },
  { path: 'form/formule/:form', component: ListFormuleFormComponent },
  { path: 'form/new-formule/:form', component: NewFormuleFormComponent },
  { path: 'form/edit-formule/:id', component: NewFormuleFormComponent },
  { path: 'users/list', component: ListUsersComponent },
  { path: 'users/new', component: NewUserComponent },
  { path: 'users/edit/:id', component: NewUserComponent },
  { path: 'pc003/list', component: ListPc003Component },
  { path: 'pc003-estrategia/list', component: ListPc003EstrategiaComponent },
  { path: 'pc003/list', component: ListPc003Component },
  { path: 'pc003/new/:id', component: FormPc003Component },
  { path: 'humidity/list', component: ListhumidityComponent },
  { path: 'humidity/new/:id', component: FormHumidityComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdmRoutingModule { }